<div class="search-cont m-auto text-center ml-5 mr-5">

        <form>

            <div class="form-group d-flex" style="direction: ltr !important;margin-top:0px;width: 90%;margin:auto;">
                <input
                        [formControl]="searchField"
                        type="text"
                        class="searchbar flex-grow-1 text-left pe-2 ps-2"
                        placeholder="Search"
                        i18n-placeholder="@@searchPlaceholder"
                        name="search"
                        id="search"
                        #search
                />
                <button class=" btn-sm btn-primary search-icon" style="background-color: #2B9097;"><i
                        class="fa fa-search"></i></button>
            </div>
        </form>

</div>
